import {node, nodeObj, unpkgOrNode, unpkgOrNodeObj, vendorOrThirdParty, vendorOrThirdPartyObj} from '../common/rjs-config-utils'
import joinURL from '../common/joinURL'

function merge(a, b) {
  Object.keys(b).forEach(k => {
    a[k] = a[k] || b[k]
  })
}

const defaults = {
  'santa-core-utils': '1.307.0',
  'santa-skin-utils': '1.1.0',
  'image-client-api': '1.40.0',
  imageClientLib: '1.40.0',
  zepto: '1.2.0',
  xss: '0.2.12',
  'create-react-class': '15.6.2',
  'react-dom-factories': '1.0.2',
  'prop-types': '15.6.0',
  lodash: '4.7.0',
  react: '15.5.4',
  'react-dom': '15.5.4',
  'pm-rpc': '1.0.7',
  hammerjs: '2.0.8',
  // jsVendor: {
  mobx: '3.2.2',
  mobxReact: '4.2.2',
  tweenmax: '1.19.0'
}

/**
 * @param {Object.<string, string>} versions
 * @param {*} serviceTopology
 * @param {boolean} local
 * @returns {*}
 */
export default function getViewerRjsConfig(versions, serviceTopology, local) {
  const scriptsLocation = serviceTopology.scriptsDomainUrl
  const platformSdkRoot = serviceTopology.scriptsLocationMap['js-platform-editor-sdk']

  const platformAppConfigurationUrl = serviceTopology && serviceTopology.scriptsLocationMap['js-platform-apps-configuration'] || 'https://static.parastorage.com/services/js-platform-apps-configuration/1.7.0'


  merge(versions, defaults)

  /**
   *  @type {function(pkg:string, path:string)}
   */
  const _unpkg = unpkgOrNode.bind(null, versions, local)
  /**
   *  @type {function(pkg:string, min:string, debug:string)}
   */
  const _unpkgObj = unpkgOrNodeObj.bind(null, versions, local)
  /**
   * @type {function(pkg:string, version:string, min:string)}
   */
  const _thirdParty = vendorOrThirdParty.bind(null, scriptsLocation, local)
  /**
   * @type {function(pkg:string, version:string, min:string, debug:string)}
   */
  const _thirdObj = vendorOrThirdPartyObj.bind(null, scriptsLocation, local)

  const paths = {
    // -------------- RUNTIME --------------------------------------------------------------
    wixImmutable: _unpkg('santa-core-utils', 'dist/wixImmutable'),
    lodash: _unpkg('lodash', 'lodash.min'),

    vendor: _unpkgObj('santa-bundle', 'dist/bundle.min', 'dist/bundle'),

    react: _unpkgObj('react', 'dist/react-with-addons.min', 'dist/react-with-addons'),
    mobx: nodeObj('mobx', 'lib/mobx.umd.min', 'lib/mobx.umd'),
    'mobx-react': nodeObj('mobx-react', 'index.min', 'index'),
    reactDOM: _unpkgObj('react-dom', 'dist/react-dom.min', 'dist/react-dom'),
    reactDOMServer: _unpkgObj('react-dom', 'dist/react-dom-server.min', 'dist/react-dom-server'),
    'prop-types': _unpkgObj('prop-types', 'prop-types.min', 'prop-types'),
    'create-react-class': _unpkgObj('create-react-class', 'create-react-class.min', 'create-react-class'),
    'react-dom-factories': _unpkg('react-dom-factories', 'index'),

    zepto: _unpkgObj('zepto', 'dist/zepto.min', 'dist/zepto'),
    speakingurl: _thirdParty('speakingurl', '', 'speakingurl.min'),
    immutable: _thirdObj('immutable', '3.7.5', 'dist/immutable.min', 'dist/immutable'),
    TweenMax: _thirdObj('tweenmax', versions.tweenmax, 'minified/TweenMax.min', 'uncompressed/TweenMax'), //bundle
    TweenLite: _thirdObj('tweenmax', versions.tweenmax, 'minified/TweenMax.min', 'uncompressed/TweenMax'),
    TimelineMax: _thirdObj('tweenmax', versions.tweenmax, 'minified/TweenMax.min', 'uncompressed/TweenMax'),
    ScrollToPlugin: _thirdObj('tweenmax', versions.tweenmax, 'minified/plugins/ScrollToPlugin.min', 'uncompressed/plugins/ScrollToPlugin'), //bundle
    DrawSVGPlugin: _thirdObj('tweenmax', versions.tweenmax, 'minified/plugins/DrawSVGPlugin.min', 'uncompressed/plugins/DrawSVGPlugin'),
    MorphSVGPlugin: _thirdObj('tweenmax', versions.tweenmax, 'minified/plugins/MorphSVGPlugin.min', 'uncompressed/plugins/MorphSVGPlugin'),
    Draggable: _thirdObj('tweenmax', versions.tweenmax, 'minified/utils/Draggable.min', 'uncompressed/utils/Draggable'),
    color: _thirdParty('color-convert', '0.2.0', 'color.min'),
    'date-fns': _thirdObj('date-fns', 'v1.3.0', 'date_fns.min', 'date_fns'),
    ajv: _thirdObj('ajv', '4.8.1', 'ajv.min', 'ajv.bundle'),
    jsonpatch: 'js/vendor/json-patch/json-patch.umd',
    xss: _unpkg('xss', 'dist/xss.min'), //shim
    immutableDiff: 'js/vendor/immutablejsdiff.min',
    pmrpc: _unpkg('pm-rpc', 'build/pm-rpc.min'),
    'ag-grid': _thirdObj('ag-grid', '6.2.1', 'dist/ag-grid.min', 'dist/ag-grid'),

    SoundManager: _thirdParty('soundmanager2', 'V2.97a.20150601', 'soundmanager2-nodebug-jsmin'),
    hammer: _unpkg('hammerjs', 'hammer.min'),
    mousetrap: _thirdParty('mousetrap', '1.4.6', 'mousetrap.min'),
    swfobject: _thirdParty('swfobject', '2.3.20130521', 'swfobject.min'),
    remoteDOM: _unpkg('@shimil/remote-dom', 'dist/local.min'),

    // ------------- internal -------------------------------------------------------------------
    platformUtils: node('santa-platform-utils', 'dist/platformUtils-bundle'),
    mobileCore: node('santa-mobile-core', 'dist/mobileCore'),
    mobileLayoutUtils: node('santa-mobile-core', 'dist/mobileLayoutUtils'),
    mesh: node('santa-mesh', 'dist/main'),
    skinUtils: _unpkg('santa-skin-utils', 'dist/skin-utils'),
    coreUtilsLib: _unpkg('santa-core-utils', 'dist/coreUtils'),
    imageClientLib: _unpkg('image-client-api', 'dist/imageClientApi'),
    'santa-data-fixer': _unpkg('santa-data-fixer', 'dist/santa-data-fixer'),
    wixFullstoryLoader: node('wix-fullstory-loader', 'dist/statics/app.bundle'),
    'data-capsule': _unpkg('data-capsule', 'dist/statics/frame-listener.bundle.min'),
    coreMultilingual: node('santa-multilingual', 'dist/languages'),
    'hls-light': _unpkg('hls.js', 'dist/hls.light.min'), //lazy
    hls: _unpkg('hls.js', 'dist/hls.min'), //lazy
    'promote-analytics-adapter': _unpkg('promote-analytics-adapter', 'dist/statics/analytics-event-adapter.bundle.min'),
    'js-platform-apps-configuration-editor': joinURL(platformAppConfigurationUrl, 'platform-apps-editor.min'),
    'js-platform-apps-configuration-viewer': joinURL(platformAppConfigurationUrl, 'platform-apps-viewer.min'),
    wixUiToggleSwitch: node('wix-ui-santa', 'ToggleSwitch'),
    wixUiPagination: node('wix-ui-santa', 'Pagination'),
    // ------------- TESTING -------------------------------------------------------------------
    fake: 'js/plugins/fake/src/main/fake',
    definition: 'js/plugins/definition/src/main/definition',
    ReactProxy: 'js/vendor/ReactProxy',
    Squire: 'js/vendor/squire/Squire',
    jasmine: _thirdParty('jasmine', '2.1.3', 'jasmine'),
    'jasmine-html': _thirdParty('jasmine', '2.1.3', 'jasmine-html'),
    'jasmine-boot': _thirdParty('jasmine', '2.1.3', 'jasmine-boot'),
    // ------------- DEVELOPMENT ---------------------------------------------------------------
    io: 'https://cdnjs.cloudflare.com/ajax/libs/socket.io/1.4.0/socket.io.min',
    patcher: node('santa-utils', 'common/hot/patcher'),
    hot: node('santa-utils', 'common/hot/listener')
  }

  if (platformSdkRoot) {
    paths.platformAPI = {min: joinURL(platformSdkRoot, 'lib', 'platform-api.min'), source: joinURL(platformSdkRoot, 'lib', 'platform-api')}
  }

  const wixCodePlatformBaseUrl = serviceTopology.scriptsLocationMap['wix-code-platform']
  if (wixCodePlatformBaseUrl) {
    const getPathToWixCodePlatformFile = function (filename) {
      return local ? node('wix-code-platform', `dist/${filename}`) : joinURL(wixCodePlatformBaseUrl, filename)
    }
    paths['elementory-browser-support'] = getPathToWixCodePlatformFile('es6runtime.min')
    paths['wix-data-schemas-creator'] = {
      min: getPathToWixCodePlatformFile('wix-data-schemas-creator.min'),
      source: getPathToWixCodePlatformFile('wix-data-schemas-creator')
    }
  }

  return {
    //By default load any module IDs from js/lib
    baseUrl: '/',
    //except, if the module ID starts with "app",
    //load it from the js/app directory. paths
    //config is relative to the baseUrl, and
    //never includes a ".js" extension since
    //the paths config could be for a directory.
    paths,
    // bundles: {
    //   vendor: ['reactDOM', 'reactDOMServer', 'prop-types', 'create-react-class', 'react-dom-factories', 'mobx', 'mobx-react']
    // },
    map: {
      'mobx-react': {
        'react-dom': 'reactDOM'
      }
    },
    shim: {
      color: {exports: 'Color'},
      'jasmine-html': {
        deps: ['jasmine']
      },
      'jasmine-boot': {
        deps: ['jasmine', 'jasmine-html']
      },
      SoundManager: {exports: 'soundManager'},
      ReactProxy: {
        deps: ['react'],
        exports: 'ReactProxy'
      },
      jsonpatch: {exports: 'jsonpatch'},
      xss: {exports: 'filterXSS'}
    },
    waitSeconds: 0
  }
}



// WEBPACK FOOTER //
// ./node_modules/santa-main-r/src/lib/viewer/get-rjs-config.js